import {  Grid, Link } from "@mui/material";
import { useState, useEffect } from "react";

export default function BotaoProgramacao({ foto, tipo, link }) {

    const [width, setWidth] = useState(window.innerWidth <= 1366 ? '80%' : '100%');

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth <= 1366 ? '75%' : '100%');
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Grid>
            <Link href={link} target="_blank">
                <img
                    src={foto}
                    alt={tipo}
                    style={{ width, height: 'auto' }}
                />
            </Link>
        </Grid>
    );
}
